import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
export const AdminJobListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1).openapi({
        description: 'Page number',
        example: 1,
    }),
    pageSize: z.coerce.number().int().min(1).max(100).default(20).openapi({
        description: 'Items per page',
        example: 20,
    }),
    status: z.string().optional().openapi({
        description: 'Filter by job status',
        example: 'processing',
    }),
    type: z.string().optional().openapi({
        description: 'Filter by job type',
        example: 'course_generation',
    }),
    userId: z.string().uuid().optional().openapi({
        description: 'Filter by user ID',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
    dateFrom: z.string().datetime().optional().openapi({
        description: 'Filter: created_at >= dateFrom (ISO 8601)',
        example: '2026-02-01T00:00:00.000Z',
    }),
    dateTo: z.string().datetime().optional().openapi({
        description: 'Filter: created_at <= dateTo (ISO 8601)',
        example: '2026-02-28T23:59:59.999Z',
    }),
    sortBy: z.enum(['createdAt', 'updatedAt']).default('createdAt').openapi({
        description: 'Sort field',
        example: 'createdAt',
    }),
    sortOrder: z.enum(['asc', 'desc']).default('desc').openapi({
        description: 'Sort direction',
        example: 'desc',
    }),
});
export const AdminJobIdParamSchema = z.object({
    jobId: z.string().uuid().openapi({
        description: 'Background job UUID',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
//# sourceMappingURL=adminJob.schema.js.map